/* variant-picker.js — option selection for multi-variant products.
 *
 * A custom element, deliberately: connectedCallback binds and
 * disconnectedCallback unbinds, so when the Theme Editor tears down and
 * re-inserts a section the listeners go with it. That is what prevents the
 * duplicate-handler bug that plagues document-level binding on section reload.
 *
 * No library. No framework. Formatting is never computed here — every money
 * string is rendered server-side by Liquid and read out of the JSON table, so
 * the client can never disagree with the server about currency.
 */
(function () {
  'use strict';
  if (typeof customElements === 'undefined' || customElements.get('variant-picker')) return;


  function VariantPicker() { return Reflect.construct(HTMLElement, [], VariantPicker); }
  VariantPicker.prototype = Object.create(HTMLElement.prototype);
  Object.setPrototypeOf(VariantPicker, HTMLElement);

  VariantPicker.prototype.connectedCallback = function () {
    var root = this.querySelector('[data-variant-picker]') || this;
    var dataEl = root.querySelector('[data-variant-data]');
    if (!dataEl) return;
    try { this.variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!this.variants || !this.variants.length) return;

    this.root = root;
    this.form = document.getElementById('ProductForm');
    this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.status = root.querySelector('[data-variant-status]');
    this.productUrl = root.getAttribute('data-product-url') || window.location.pathname;

    this._onChange = this.onChange.bind(this);
    this._onPop = this.onPop.bind(this);
    root.addEventListener('change', this._onChange);
    window.addEventListener('popstate', this._onPop);

    // A ?variant= in the URL is authoritative on first paint: a shared or
    // bookmarked link must land on the variant it names, not the default.
    var wanted = new URLSearchParams(window.location.search).get('variant');
    if (wanted) this.selectById(parseInt(wanted, 10), { push: false });
    else this.refresh({ push: false, announce: false });
  };

  VariantPicker.prototype.disconnectedCallback = function () {
    if (this.root) this.root.removeEventListener('change', this._onChange);
    window.removeEventListener('popstate', this._onPop);
  };

  VariantPicker.prototype.chosen = function () {
    var out = [];
    this.root.querySelectorAll('[data-option-index]').forEach(function (el) {
      if (el.tagName === 'INPUT' && el.checked) out[parseInt(el.dataset.optionIndex, 10)] = el.value;
    });
    return out;
  };

  VariantPicker.prototype.match = function (opts) {
    return this.variants.filter(function (v) {
      return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
    })[0] || null;
  };

  VariantPicker.prototype.selectById = function (id, o) {
    var v = this.variants.filter(function (x) { return x.id === id; })[0];
    if (!v) return this.refresh({ push: false, announce: false });
    var self = this;
    v.options.forEach(function (val, i) {
      var input = self.root.querySelector('input[data-option-index="' + i + '"][value="' + CSS.escape(val) + '"]');
      if (input) input.checked = true;
    });
    this.refresh(o || {});
  };

  VariantPicker.prototype.onChange = function (e) {
    if (!e.target.matches('input[data-option-index]')) return;
    this.refresh({ push: true, announce: true });
  };

  VariantPicker.prototype.onPop = function () {
    var id = new URLSearchParams(window.location.search).get('variant');
    if (id) this.selectById(parseInt(id, 10), { push: false, announce: true });
  };

  VariantPicker.prototype.refresh = function (o) {
    o = o || {};
    var v = this.match(this.chosen());
    this.markUnavailable();

    var btn = document.querySelector('[data-add]');
    var label = document.querySelector('[data-add-label]');
    var now = document.querySelector('[data-price-now]');
    var was = document.querySelector('[data-price-was]');
    var badge = document.querySelector('[data-price-badge]');
    var img = document.querySelector('.pdp__img');

    if (!v) {
      // A combination Shopify has no variant for must not be purchasable.
      if (btn) btn.disabled = true;
      if (label) label.textContent = btn ? (btn.getAttribute('data-label-unavailable') || '') : '';
      if (this.idInput) this.idInput.value = '';
      return;
    }

    if (this.idInput) this.idInput.value = String(v.id);   // Shopify's own ID, never inferred
    if (now) now.textContent = v.price;
    if (was) { was.textContent = v.compare_at || ''; was.hidden = !v.compare_at; }
    if (badge) {
      if (v.compare_at && v.discount) {
        badge.textContent = '−' + v.discount + '%';
        badge.hidden = false;
      } else { badge.hidden = true; badge.textContent = ''; }
    }
    if (btn) {
      btn.disabled = !v.available;
      if (label) label.textContent = v.available
        ? (btn.getAttribute('data-label-add') || label.textContent)
        : (btn.getAttribute('data-label-unavailable') || '');
    }
    if (img && v.image) { img.src = v.image; img.removeAttribute('srcset'); }

    if (o.push !== false && window.history && history.replaceState) {
      var selectedUrl = new URL(window.location.href);
      selectedUrl.searchParams.set('variant', v.id);
      history.replaceState({ variant: v.id }, '', selectedUrl.pathname + selectedUrl.search + selectedUrl.hash);
    }
    var structured = document.getElementById('ProductStructuredData');
    if (structured) {
      try {
        var productData = JSON.parse(structured.textContent);
        var offerUrl = new URL(this.productUrl, window.location.origin);
        offerUrl.searchParams.set('variant', v.id);
        productData.url = offerUrl.href;
        productData.sku = v.sku;
        if (v.image) productData.image = [new URL(v.image, window.location.origin).href];
        if (productData.offers) {
          productData.offers.price = v.schema_price;
          productData.offers.availability = 'https://schema.org/' + (v.available ? 'InStock' : 'OutOfStock');
          productData.offers.url = offerUrl.href;
        }
        structured.textContent = JSON.stringify(productData).replace(/</g, '\\u003c');
      } catch (e) { }
    }
    if (o.announce && this.status) {
      this.status.textContent = v.options.join(' · ') + ' — ' + v.price +
        (v.available ? '' : ' (' + (btn ? btn.getAttribute('data-label-unavailable') || '' : '') + ')');
    }
  };

  // Grey out values that cannot combine with what is already chosen, and say so
  // in text as well as styling.
  VariantPicker.prototype.markUnavailable = function () {
    var self = this;
    var chosen = this.chosen();
    this.root.querySelectorAll('input[data-option-index]').forEach(function (input) {
      var i = parseInt(input.dataset.optionIndex, 10);
      var probe = chosen.slice();
      probe[i] = input.value;
      var exists = self.variants.some(function (v) {
        return v.options.every(function (o, k) { return probe[k] === undefined || o === probe[k]; }) && v.available;
      });
      input.disabled = !exists;
      var flag = input.nextElementSibling && input.nextElementSibling.querySelector('[data-sold-out-flag]');
      if (flag) flag.hidden = exists;
    });
  };

  customElements.define('variant-picker', VariantPicker);
})();
